/**
 * SkipLink — first focusable element of the page: «Saltar al contenido principal».
 * Hidden until it receives the keyboard focus. Moves the focus to `#main-content`
 * itself instead of letting the browser add `#main-content` to the URL.
 */

import { useTranslation } from '@platform/i18n/hooks/useTranslation'

const MAIN_ID = 'main-content'

export const SkipLink: React.FC = () => {
  const { t } = useTranslation('common')

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const main = document.getElementById(MAIN_ID)
    if (!main) return
    event.preventDefault()
    main.focus()
  }

  return (
    <a
      href={`#${MAIN_ID}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[10000] focus:rounded-md focus:bg-crypto-card focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-crypto-text focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-crypto-accent"
    >
      {t('a11y.skipToContent')}
    </a>
  )
}
